import React from "react";
import { Breadcrumbs } from "../../../components/Breadcrumbs";
import { useLocation } from "react-router";
import { FormatDate } from "../../../components/FormatDate";
import { SkyButton } from "../../../components/Buttons";
import OrderProduct from "./OrderProduct";
import FormatPrice from "../../../components/FormatPrice";
import { useSelector } from "react-redux";

const OrderDetails = () => {
  const location = useLocation();

  const orderData = location.state !== null ? location.state.propData : "";
  const domainType = orderData && orderData.company.domain.type;
  const user = useSelector((state) => state?.auth?.data);
  const addressList = user?.addressList || [];

  const handleInvoice = () => { };
  const orderSummary = [
    { id: 1, title: "items' subtotal" },
    { id: 2, title: "shipping" },
    { id: 3, title: "tax" },
    { id: 4, title: "grand total " },
  ];

  return (
    <div className="p-3">
      <Breadcrumbs
        base={domainType === "RETAIL" ? "my orders" : "my enrollments"}
        currentNav={"Order Details"}
        baseLink={"/profile/myorders"}
      />
      {/* order details */}
      <div className="w-full md:w-1/2 mt-2 ">
        <h2 className="text-3xl font-medium font-sans mb-1">
          Order Details
          {/* {domainType === "RETAIL" ? "my orders" : "my enrollments"} */}
        </h2>
      </div>
      <div className="flex justify-between mb-4">
        <p className="text-sm ">
          Ordered on {FormatDate(orderData?.createdDate)} | Order #{" "}
          {orderData?.number}
        </p>
        <SkyButton title={"view or print voice"} handleClick={handleInvoice} />
      </div>

      {/* shipment details */}
      <div className="border shadow rounded-lg capitalize mb-4">
        <div className="mx-auto max-w-7xl px-2 lg:px-4 p-4 sm:px-8">
          <div className="grid gap-y-8 sm:grid-cols-2 sm:gap-12 md:grid-cols-2 lg:grid-cols-3">
            {/* shipping */}
            <div>
              <p className="text-sm font-semibold capitalize text-black  ">
                shipping address
              </p>

              {addressList.map((address, index) => (
                <p key={index} className="mt-4 text-sm text-gray-600 break-words font-sans font-bold">
                  {address.streetName1}, {address.streetName2}, {address.city}, {address.state}, {address.zipcode}, {address.country}
                </p>
              ))}
            </div>
            {/* payment */}
            <div>
              <p className="text-sm font-semibold capitalize text-black ">
                payment method
              </p>

              <p className="mt-4 text-sm text-gray-600 break-words font-sans font-bold">
                AMEX account ending in 2432
              </p>
            </div>
            {/* summary */}
            <div>
              <p className="text-sm font-semibold capitalize text-black ">
                order summary
              </p>

              <div className="flex justify-between mt-4">
                <div className="">
                  {orderSummary.map((summ) => (
                    <p
                      className="text-sm text-gray-600 break-words font-sans font-bold"
                      key={summ.id}
                    >
                      {summ.title}
                    </p>
                  ))}
                </div>

                <div className="w-3/5 md:w-1/2">
                  <p className=" text-sm text-gray-600 font-sans font-bold tracking-wider">
                    <FormatPrice price={orderData?.subtotalAmount} />
                  </p>
                  <p className=" text-sm text-gray-600 font-sans font-bold tracking-wider">
                    <FormatPrice price={orderData?.shippingAndHandlingAmount} />
                  </p>
                  <p className=" text-sm text-gray-600 font-sans font-bold tracking-wider">
                    <FormatPrice price={orderData?.tax} />
                  </p>
                  <p className=" text-sm text-gray-800 font-sans font-bold tracking-wider break-words">
                    <FormatPrice price={orderData?.totalAmount} />
                  </p>
                </div>
              </div>

              {/* <div className="flex justify-between">
                <p className="mt-4 text-sm text-gray-600 break-words font-sans font-bold">
                  item(s) subtotal
                </p>
                <p className="mt-4 text-sm text-gray-600 font-sans font-bold">
                  <FormatPrice price={0} />
                </p>
              </div> */}
            </div>
          </div>
        </div>

        {/* <div className="bg-transparent border-t rounded-se-xl p-3">
          <p className="text-sm text-sky-800 px-4">transaction</p>
        </div> */}
      </div>

      {/* ordered products */}
      <div className="border shadow rounded-lg">
        <div className="bg-gray-100 rounded-se-xl p-2">
          <p className="text-md font-semibold px-4">
            {orderData.lineItemList.length} Shipments
          </p>
        </div>
        <div className="border-t">
          {orderData &&
            orderData.lineItemList.map((prodItem) => (
              <OrderProduct
                key={
                  domainType === "RETAIL"
                    ? prodItem.product._id
                    : prodItem.scheduledProduct._id
                }
                productItem={
                  domainType === "RETAIL"
                    ? prodItem.product
                    : prodItem.scheduledProduct.product
                }
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
